import Fashion from '@/components/views/Fashion'

export default {
  path: '/home/fashion',
  name: 'cn.fashion',
  meta: {
    name: 'fashion',
    locale: 'cn'
  },
  component: Fashion
}



// WEBPACK FOOTER //
// ./src/router/routes/cn/fashion.js